import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type TripsQueryVariables = Types.Exact<{
	planningCursor?: Types.InputMaybe<Types.Scalars['Cursor']['input']>
	publishedCursor?: Types.InputMaybe<Types.Scalars['Cursor']['input']>
	purchasedCursor?: Types.InputMaybe<Types.Scalars['Cursor']['input']>
}>

export type TripsQuery = {
	__typename?: 'Query'
	published: {
		__typename?: 'TripConnection'
		totalCount: number
		pageInfo: {
			__typename?: 'PageInfo'
			endCursor?: string | null
			hasNextPage: boolean
			hasPreviousPage: boolean
			startCursor?: string | null
		}
		edges?: Array<{
			__typename?: 'TripEdge'
			cursor: string
			node?: {
				__typename: 'Trip'
				id: string
				title?: string | null
				description?: string | null
				departAt?: string | null
				returnAt?: string | null
				isOwner: boolean
				isIndestructible: boolean
				numDestinations: number
				numBlocks: number
				numSources: number
				numHighlights: number
				isPurchased: boolean
				weekendCostRangeUpper?: number | null
				weekendCostRangeLower?: number | null
				weekCostRangeUpper?: number | null
				weekCostRangeLower?: number | null
				monthCostRangeUpper?: number | null
				monthCostRangeLower?: number | null
				categories?: Array<string> | null
				owner?: {
					__typename: 'User'
					id: string
					email: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				} | null
				unpublishedListing?: {
					__typename: 'Listing'
					id: string
					isPublished: boolean
					rank: number
					title?: string | null
					description?: string | null
					basePrice?: number | null
					currency: string
					viewsCount: number
					thankYouMessage?: string | null
					suggestedPrice?: number | null
					avgRating: number
					numReviews: number
					owner: {
						__typename: 'User'
						id: string
						bio?: string | null
						instagramUsername?: string | null
						tiktokUsername?: string | null
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
					reviews?: Array<{
						__typename: 'Review'
						id: string
						starRating: number
						feedbackToCreator?: string | null
						comment?: string | null
						createdAt: string
						reviewer: {
							__typename: 'User'
							id: string
							username?: string | null
							currentName: string
							currentProfilePictureUrl: string
						}
					}> | null
				} | null
				featuredHighlights: Array<{
					__typename: 'Block'
					featuredImagePosition?: number | null
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					highlightPosition: number
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
					parentBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
						position: number
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
					} | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
				} | null>
				yourPurchase?: {
					__typename: 'Purchase'
					id: string
					review?: { __typename: 'Review'; id: string } | null
				} | null
			} | null
		} | null> | null
	}
	planning: {
		__typename?: 'TripConnection'
		totalCount: number
		pageInfo: {
			__typename?: 'PageInfo'
			endCursor?: string | null
			hasNextPage: boolean
			hasPreviousPage: boolean
			startCursor?: string | null
		}
		edges?: Array<{
			__typename?: 'TripEdge'
			cursor: string
			node?: {
				__typename: 'Trip'
				id: string
				title?: string | null
				description?: string | null
				departAt?: string | null
				returnAt?: string | null
				isOwner: boolean
				isIndestructible: boolean
				numDestinations: number
				numBlocks: number
				numSources: number
				numHighlights: number
				isPurchased: boolean
				weekendCostRangeUpper?: number | null
				weekendCostRangeLower?: number | null
				weekCostRangeUpper?: number | null
				weekCostRangeLower?: number | null
				monthCostRangeUpper?: number | null
				monthCostRangeLower?: number | null
				categories?: Array<string> | null
				owner?: {
					__typename: 'User'
					id: string
					email: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				} | null
				unpublishedListing?: {
					__typename: 'Listing'
					id: string
					isPublished: boolean
					rank: number
					title?: string | null
					description?: string | null
					basePrice?: number | null
					currency: string
					viewsCount: number
					thankYouMessage?: string | null
					suggestedPrice?: number | null
					avgRating: number
					numReviews: number
					owner: {
						__typename: 'User'
						id: string
						bio?: string | null
						instagramUsername?: string | null
						tiktokUsername?: string | null
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
					reviews?: Array<{
						__typename: 'Review'
						id: string
						starRating: number
						feedbackToCreator?: string | null
						comment?: string | null
						createdAt: string
						reviewer: {
							__typename: 'User'
							id: string
							username?: string | null
							currentName: string
							currentProfilePictureUrl: string
						}
					}> | null
				} | null
				featuredHighlights: Array<{
					__typename: 'Block'
					featuredImagePosition?: number | null
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					highlightPosition: number
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
					parentBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
						position: number
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
					} | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
				} | null>
				yourPurchase?: {
					__typename: 'Purchase'
					id: string
					review?: { __typename: 'Review'; id: string } | null
				} | null
			} | null
		} | null> | null
	}
	purchased: {
		__typename?: 'TripConnection'
		totalCount: number
		pageInfo: {
			__typename?: 'PageInfo'
			endCursor?: string | null
			hasNextPage: boolean
			hasPreviousPage: boolean
			startCursor?: string | null
		}
		edges?: Array<{
			__typename?: 'TripEdge'
			cursor: string
			node?: {
				__typename: 'Trip'
				id: string
				title?: string | null
				description?: string | null
				departAt?: string | null
				returnAt?: string | null
				isOwner: boolean
				isIndestructible: boolean
				numDestinations: number
				numBlocks: number
				numSources: number
				numHighlights: number
				isPurchased: boolean
				weekendCostRangeUpper?: number | null
				weekendCostRangeLower?: number | null
				weekCostRangeUpper?: number | null
				weekCostRangeLower?: number | null
				monthCostRangeUpper?: number | null
				monthCostRangeLower?: number | null
				categories?: Array<string> | null
				owner?: {
					__typename: 'User'
					id: string
					email: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				} | null
				unpublishedListing?: {
					__typename: 'Listing'
					id: string
					isPublished: boolean
					rank: number
					title?: string | null
					description?: string | null
					basePrice?: number | null
					currency: string
					viewsCount: number
					thankYouMessage?: string | null
					suggestedPrice?: number | null
					avgRating: number
					numReviews: number
					owner: {
						__typename: 'User'
						id: string
						bio?: string | null
						instagramUsername?: string | null
						tiktokUsername?: string | null
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
					reviews?: Array<{
						__typename: 'Review'
						id: string
						starRating: number
						feedbackToCreator?: string | null
						comment?: string | null
						createdAt: string
						reviewer: {
							__typename: 'User'
							id: string
							username?: string | null
							currentName: string
							currentProfilePictureUrl: string
						}
					}> | null
				} | null
				featuredHighlights: Array<{
					__typename: 'Block'
					featuredImagePosition?: number | null
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					highlightPosition: number
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
					parentBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
						position: number
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
					} | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
				} | null>
				yourPurchase?: {
					__typename: 'Purchase'
					id: string
					review?: { __typename: 'Review'; id: string } | null
				} | null
			} | null
		} | null> | null
	}
}

export type TripsByFilterQueryVariables = Types.Exact<{
	first?: Types.InputMaybe<Types.Scalars['Int']['input']>
	after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>
	before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>
	last?: Types.InputMaybe<Types.Scalars['Int']['input']>
	filter: Types.TripPaginationFilter
}>

export type TripsByFilterQuery = {
	__typename?: 'Query'
	tripConnection: {
		__typename?: 'TripConnection'
		totalCount: number
		pageInfo: {
			__typename?: 'PageInfo'
			endCursor?: string | null
			hasNextPage: boolean
			hasPreviousPage: boolean
			startCursor?: string | null
		}
		edges?: Array<{
			__typename?: 'TripEdge'
			cursor: string
			node?: {
				__typename: 'Trip'
				id: string
				title?: string | null
				description?: string | null
				departAt?: string | null
				returnAt?: string | null
				isOwner: boolean
				isIndestructible: boolean
				numDestinations: number
				numBlocks: number
				numSources: number
				numHighlights: number
				isPurchased: boolean
				weekendCostRangeUpper?: number | null
				weekendCostRangeLower?: number | null
				weekCostRangeUpper?: number | null
				weekCostRangeLower?: number | null
				monthCostRangeUpper?: number | null
				monthCostRangeLower?: number | null
				categories?: Array<string> | null
				owner?: {
					__typename: 'User'
					id: string
					email: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				} | null
				unpublishedListing?: {
					__typename: 'Listing'
					id: string
					isPublished: boolean
					rank: number
					title?: string | null
					description?: string | null
					basePrice?: number | null
					currency: string
					viewsCount: number
					thankYouMessage?: string | null
					suggestedPrice?: number | null
					avgRating: number
					numReviews: number
					owner: {
						__typename: 'User'
						id: string
						bio?: string | null
						instagramUsername?: string | null
						tiktokUsername?: string | null
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
					reviews?: Array<{
						__typename: 'Review'
						id: string
						starRating: number
						feedbackToCreator?: string | null
						comment?: string | null
						createdAt: string
						reviewer: {
							__typename: 'User'
							id: string
							username?: string | null
							currentName: string
							currentProfilePictureUrl: string
						}
					}> | null
				} | null
				featuredHighlights: Array<{
					__typename: 'Block'
					featuredImagePosition?: number | null
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					highlightPosition: number
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
					parentBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
						position: number
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
					} | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
				} | null>
				yourPurchase?: {
					__typename: 'Purchase'
					id: string
					review?: { __typename: 'Review'; id: string } | null
				} | null
			} | null
		} | null> | null
	}
}

export const TripsDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Trips' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'planningCursor' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'publishedCursor' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'purchasedCursor' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'published' },
						name: { kind: 'Name', value: 'tripConnection' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'where' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'EnumValue', value: 'Published' },
										},
									],
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'IntValue', value: '5' },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'publishedCursor' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripEdge' } }],
						},
					},
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'planning' },
						name: { kind: 'Name', value: 'tripConnection' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'where' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'EnumValue', value: 'Planning' },
										},
									],
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'IntValue', value: '5' },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'planningCursor' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripEdge' } }],
						},
					},
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'purchased' },
						name: { kind: 'Name', value: 'tripConnection' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'where' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'EnumValue', value: 'Purchased' },
										},
									],
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'IntValue', value: '5' },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'purchasedCursor' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripEdge' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripEdge' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripConnection' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'pageInfo' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'edges' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'node' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripsFields' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripsFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'categories' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicUserFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'featuredHighlights' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HighlightBlockFields' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'featuredImagePosition' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'yourPurchase' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'review' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicUserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'HighlightBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'highlightPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const TripsByFilterDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'TripsByFilter' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'TripPaginationFilter' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'tripConnection' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'where' },
								value: {
									kind: 'ObjectValue',
									fields: [
										{
											kind: 'ObjectField',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
										},
									],
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'before' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'last' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripEdge' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripEdge' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripConnection' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'pageInfo' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'edges' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'node' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripsFields' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripsFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'categories' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicUserFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'featuredHighlights' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HighlightBlockFields' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'featuredImagePosition' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'yourPurchase' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'review' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicUserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'HighlightBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'highlightPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
	],
} as unknown as DocumentNode
